import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TransactionDetailsListItem from './TransactionDetailsListItem';
import { formatTransactionDetails } from '../../utils/formatTransactionDetails';
import { format } from 'date-fns';
import { ErrorTransactions } from '../../../client/Juno/client/constant';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import JncPaymentConfirmation from '../profile/JncPaymentConfirmation';

const TransactionMobileDialog = ({ openDialog, handleClose, transaction }) => {
    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);
    return (
        <div>
            <Dialog open={openDialog} onClose={handleClose} fullScreen>
                <DialogContent className="p-0 bg-container-bg">
                    <div className="h-[60px] relative bg-modal-bg rounded-bl-lg rounded-br-lg border-b  border-[#0000001F] dark:border-[#FFFFFF1F] ">
                        <div className="py-[14px] px-6 flex items-center justify-center relative h-full">
                            <div className="absolute left-6" onClick={handleClose}>
                                <ArrowBackIcon className=" !text-text" />
                            </div>
                            <div className="flex flex-col items-center">
                                <p className="text-center text-base font-semibold !text-text uppercase flex flex-row">
                                    {activeCurrencyPage === 'fiat' && transaction?.type === 'Buy'
                                        ? 'Transfer (Out)'
                                        : activeCurrencyPage === 'fiat' &&
                                            transaction?.type === 'Sell'
                                          ? 'Transfer (In)'
                                          : transaction?.type}
                                </p>
                                <p className="self-stretch text-center justify-start text-balanceCard-manage text-sm font-medium ">
                                    {format(transaction?.createdDate, 'dd.MM.yy HH:mm')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className=" p-6 bg-modal-bg rounded-lg border-t-[4px] border-[#0000001F] dark:border-[#FFFFFF1F] ">
                        {ErrorTransactions.includes(transaction.status.code) && (
                            <div className="self-stretch p-4 bg-[#B62B2B1F] dark:bg-[#F970661F] rounded-md inline-flex flex-col justify-center items-start gap-2 overflow-hidden w-full mb-6">
                                <div className="w-6 h-6 relative overflow-hidden">
                                    <ErrorOutlineIcon className="!text-error" />
                                </div>
                                <div className="self-stretch flex flex-col justify-center items-start gap-0.5">
                                    <div className="self-stretch justify-start text-badge-text-failed text-xs font-semibold uppercase">
                                        {transaction.status.message}
                                    </div>
                                </div>
                            </div>
                        )}
                        {transaction?.status.code === 'PrivateClient:TransactionCompleted' &&
                            ['Withdrawal', 'Payment Out'].includes(transaction?.type) && (
                                <div className="py-3 col-span-full rounded-md">
                                    <JncPaymentConfirmation data={transaction} />
                                </div>
                            )}

                        <div className="flex flex-col gap-1">
                            {formatTransactionDetails(transaction).map(item => {
                                if (item?.value) {
                                    return (
                                        <TransactionDetailsListItem
                                            key={`${item.label}-${item.value}`}
                                            label={item.label}
                                            value={item.value}
                                            copyText={item.copyText}
                                        />
                                    );
                                }
                            })}
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
};

TransactionMobileDialog.propTypes = {
    openDialog: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    transaction: PropTypes.object.isRequired,
};

export default TransactionMobileDialog;
